import styled from 'styled-components';
import { IonFooter, IonToolbar } from '@ionic/react';

type OnBoardingFooterProps = {
  isPopup: boolean;
};

export const OnBoardingFooterStyled = styled(IonFooter)`
  &::before {
    display: none;
  }
`;

export const OnBoardingToolbarStyled = styled(IonToolbar)<OnBoardingFooterProps>`
  --background: ${({ isPopup }) => (isPopup ? '#EEEEEE' : '#ffffff')};
  --border-style: none;
  --padding-bottom: 0;
  --padding-end: 0;
  --padding-start: 0;
  --padding-top: 0;
  border-radius: ${({ isPopup }) => (isPopup ? '20px 20px 0px 0px' : 'none')};

  & button {
    background: #f24e1e;
    font-weight: 600;
    font-size: 18px;
    line-height: 24px;
    color: #f5f9ff;
  }

  & button:active {
    background: #c13e18;
  }

  & button:disabled {
    background: #c1c1c1;
  }

  & .withPopup {
    background: #fafafb;
    border-radius: 20px 20px 0px 0px;
  }
`;
